export const formatNumber = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined) {
    return '';
  }
  
  const num = typeof value === 'string' ? parseFloat(value) : value;
  
  if (isNaN(num)) {
    return String(value);
  }
  
  return num.toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3
  });
};

export const formatCurrency = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined) {
    return '';
  }
  
  const num = typeof value === 'string' ? parseFloat(value) : value;
  
  if (isNaN(num)) {
    return String(value);
  }
  
  return num.toLocaleString('ru-RU', {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3
  });
}; 